import { useState, useEffect } from 'react';
import ("../../styles/weather.scss");

const Weather = ({ location }) => {
  const [weather, setWeather] = useState(null);
  const [error, setError] = useState(null);

  const apiKey = process.env.REACT_APP_WEATHER;

  useEffect(() => {
    const fetchWeather = async () => {
      try {
        const response = await fetch(
          `https://api.weatherapi.com/v1/current.json?key=${apiKey}&q=${location}`
        );
        if (!response.ok) throw new Error('Failed to fetch weather data');
        const data = await response.json();
        setWeather(data);
      } catch (err) {
        setError(err.message);
      }
    };

    fetchWeather();
  }, [location, apiKey]);

  if (error) return <div id="Weather">Error: {error}</div>;
  if (!weather) return <div id="Weather"><h2>Loading...</h2></div>;

  return (
    <div id="Weather">
        <h2>Weather in {weather.location.name}</h2>
        <p>
            <img src={weather.current.condition.icon} alt={weather.current.condition.text} width="64" height="64"/>
            {weather.current.temp_f} °F
        </p>
        <p>{weather.current.condition.text}</p>
    </div>
  );
};

export default Weather;